
<template>
<el-menu
  v-if="showMenu"
  router
  collapse-transition
  style="height: calc(100vh - 50px); overflow: auto;"
  :default-active="$route.path">
  <template v-for="(item, i) in data">
    <el-submenu :index="item.url" :key="i" v-if="item.children && nodeVisible(item)">
      <template slot="title">
        <i :class="'icon ' + item.icon"></i>
        <span>{{ item.name }}</span>
      </template>
      <ui-menu-tree :data="item.children"></ui-menu-tree>
    </el-submenu>
    <el-menu-item v-if="!item.children" :key="'chi' + i" :index="item.url">
      <template slot="title">
        <i v-if="item.icon" :class="'icon ' + item.icon"></i>
        <span>{{ item.name }}</span>
      </template>
    </el-menu-item>
  </template>
</el-menu>
</template>

<script>
import { getRoletype } from '@/utils/getUser' 
import { getAccountId } from '@/directives/permission'
import { isMenuVisible } from '@/utils/menuPermission'
export default {
name: 'ui-menu',
  name: 'ui-menu',
  props: {
    data: {
      type: Array,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    isGLY () {
      return this.roleName.includes('管理员')
    }
  },
  data () {
    return {
      showMenu: false,
      interval: null,
      switchConfig: {},
      roleName: [],
      roleType: null, // 添加 roleType 状态
      accountId: '' // 供报单汇总等账号特例判断
    }
  },
  created() {
    this.waitForRoleType()
    this.accountId = getAccountId()
    this.getSwitchConfig()
    this.interval = setInterval(() => {
      this.getSwitchConfig()
    }, 100)
    this.roleName = this.getRoleName()
  },
  methods: {
    /**
     * 等待 roleType 加载完成
     */
    async waitForRoleType() {
      const maxAttempts = 30 // 最多等待 3 秒
      let attempts = 0
      
      const check = () => {
        const roleType = getRoletype()
        if (roleType) {
          this.roleType = roleType
          return true
        }
        return false
      }
      
      // 立即检查一次
      if (check()) return
      
      // 如果没有，轮询检查
      const intervalId = setInterval(() => {
        attempts++
        if (check() || attempts >= maxAttempts) {
          clearInterval(intervalId)
          // 即使超时也设置一个默认值，避免一直不显示菜单
          if (!this.roleType) {
            this.roleType = getRoletype() || 0
          }
        }
      }, 100)
    },
    nodeVisible(item) {
      // roleType 未加载完成时，隐藏所有需要权限判断的菜单
      if (!this.roleType) {
        return false
      }
      
      return isMenuVisible(item, this.roleType, this.accountId)
    },
    /**
     * 过滤树节点，如果节点或其子节点匹配条件则显示
     * @param {Array} data - 原始树形数据
     * @param {string} keyword - 搜索关键词
     * @returns {Array} - 过滤后的树形数据
     */
    filterTree: (data, keyword) => {
      // 深拷贝数据，避免影响原始数据
      const tree = JSON.parse(JSON.stringify(data))
      
      // 判断节点是否符合条件
      const isMatch = (node) => {
        return node.oname.includes(keyword)
      }
      
      // 递归处理树节点
      const filterNode = (nodes) => {
        return nodes.filter(node => {
          // 处理子节点
          if (node.children && node.children.length) {
            node.children = filterNode(node.children)
          }
          
          // 如果子节点匹配或当前节点匹配，则保留该节点
          return isMatch(node) || (node.children && node.children.length > 0)
        })
      }
      
      return filterNode(tree)
    },
    getSwitchConfig () {
      this.showMenu = false
      this.switchConfig = {}
      let switchConfigStr = sessionStorage.getItem('SWITCH_CONFIG')
      if (switchConfigStr) {
        let switchConfig = JSON.parse(switchConfigStr)
        for (let i = 0; i < switchConfig.length; i++) {
          this.switchConfig[switchConfig[i].switchType] = switchConfig[i].switchState
        }
      }
      this.showMenu = true
    }
  },
  destroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: contain;
  margin: 0 8px 0 0 ;
  color: #fff;
}
.icon + span {
  vertical-align: middle;
}
.light-color {
  color: #666;
}
.el-menu-item.is-active {
  /* color: #fff;
  background: linear-gradient(45deg, #4F8AFF 0%, #4B5EFF 100%);
  border-radius: 8px; */
  color: #4F8AFF;
  background-color: rgba(79, 138, 255, 0.125);
}
.el-submenu {
  margin: 0;
}
::v-deep .el-submenu.is-active .el-submenu__title,
::v-deep .el-submenu.is-active .icon {
  color: #4F8AFF;
}
</style>
